import bindEvent from '../../scripts/util/bindEvent';
import addClass from '../../scripts/util/DOM/addClass';
import {contains, remove, indexOf} from 'ramda';
import $ from 'jquery';

const selectors = {
	item: '.filter__item:not(.filter__item_active)',
	reset: '.filter__item_active',
	select: '.js-filter-select > select',
	catalogMenu: '.js-menu-catalog-top',
	catalogMenuFilterItem: '.js-menu-catalog-top li[data-filter=all]',
	mobileSelect: '.js-filter-select',
	clientsPage: '.js-clients', // clientsPage: '.clients',
	clientsHeaderTitle: '.js-clients-heading-title',
	clientsHeaderText: '.js-clients-heading-text'
};

const classes = {
	active: 'filter__item_active',
	activeSelect: 'select_state_open'
};

let values = [];

const pushValue = value => {
	if (!contains(value, values)) {
		values.push(value);
		return values.filter(x => x !== null);
	}

	return values;
};

const removeValue = value => {
	const index = indexOf(value, values);
	if (index > -1) {
		return remove(index, index + 1, values);
	}

	return values;
};

const unSelect = callback => e => {
	const current = e.currentTarget;
	const value = current.getAttribute('data-filter');
	values = removeValue(value);
	current.classList.remove(classes.active);

	if ($(selectors.clientsPage).length > 0) {
		const hash = window.location.hash;
		if (hash.length > 0) {
			history.pushState({clients: value}, 'Title', '/' + $('[data-page-pushstate]').data('page-pushstate'));
		}
	}

	if ($(selectors.catalogMenu).length > 0 && values.length === 0) {
		callback('all');
	} else {
		callback(values);
	}
};

const select = callback => e => {
	const current = e.currentTarget;
	const value = current.getAttribute('data-filter');
	const isActive = current.classList.contains(classes.active);

	if (isActive && value !== 'all' && $(selectors.catalogMenu).length === 0) {
		return unSelect(callback)(e);
	}

	values = pushValue(value);

	if ($(selectors.catalogMenu).length > 0) {
		$(selectors.reset).removeClass(classes.active);

		values.length = 0;
		values = pushValue(value);
	}

	if ($(selectors.clientsPage).length > 0) {
		$(selectors.reset).removeClass(classes.active);

		const headerTitles = $('#headerTitles').length ? JSON.parse($('#headerTitles').html()) : [];
		const headerTitle = headerTitles[value];
		const headerTexts = $('#headerTexts').length ? JSON.parse($('#headerTexts').html()) : [];
		const headerText = headerTexts[value];
		$(selectors.clientsHeaderTitle).html(headerTitle);
		$(selectors.clientsHeaderText).html(headerText);

		values.length = 0;
		values = pushValue(value);
		if (value === 'all') {
			history.pushState({clients: value}, 'Title', '/' + $('[data-page-pushstate]').data('page-pushstate'));
		} else {
			history.pushState({clients: value}, 'Title', '/' + $('[data-page-pushstate]').data('page-pushstate') + '/' + value);
		}
	}

	addClass(classes.active)(current);

	callback(values);
};

const mobileSelect = callback => e => {
	const value = e.currentTarget.value;
	if (parseInt(value) === 0) {  // eslint-disable-line
		callback([]);
	} else {
		callback(value);
	}

	if (value === 'all') {
		history.pushState({clients: value}, 'Title', '/' + $('[data-page-pushstate]').data('page-pushstate'));
	} else {
		history.pushState({clients: value}, 'Title', '/' + $('[data-page-pushstate]').data('page-pushstate') + '/' + value);
	}
};

const render = callback => {
	const lg = window.innerWidth <= 1024;
	bindEvent(selectors.item, 'click', select(callback));
	bindEvent(selectors.reset, 'click', unSelect(callback));

	if ($(selectors.clientsPage).length > 0) {
		const path = window.location.pathname.substring(1).split('/');
		if (path.length >= 2) {
			$('li[data-filter=' + path[1] + ']').trigger('click');
		}
		else {
			$('li[data-filter=all]').addClass(classes.active);
		}
	}

	if (lg) {
		bindEvent(selectors.select, 'change', mobileSelect(callback));
	}
};

export default render;
